import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import OutlinedButton from 'components/Buttons/OutlinedButton';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';

export interface ApproveRetakeButtonsProps {
  onApproveClick?: () => void;
  onRetakeClick?: () => void;
  hideApprove?: boolean;
  hideRetake?: boolean;
  approveText?: string;
  retakeText?: string;
  className?: string;
}

function ApproveRetakeButtons(props: ApproveRetakeButtonsProps) {
  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.actions}>
        {!props.hideApprove && (
          <div className={clsx(styles.button, styles.approveBtn)}>
            <ButtonWithArrowIcon onClick={props.onApproveClick}>
              {props.approveText || 'Approve'}
            </ButtonWithArrowIcon>
          </div>
        )}
        {!props.hideRetake && (
          <div className={clsx(styles.button, styles.retakeBtn)}>
            <OutlinedButton onClick={props.onRetakeClick}>
              {props.retakeText || 'Retake'}
            </OutlinedButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default ApproveRetakeButtons;
